import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { PagingResultModelOfAuditRecordModel, GetAuditRecordsInput } from '../gql-types.generated';

export const QUERY_AUDIT_RECORD_LIST = gql`
  query auditRecordList($input: GetAuditRecordsInput!) {
    auditRecords(input: $input) {
      cursor {
        nextPage
        previousPage
      }
      totalCount
      nodes {
        id
        createdTime
        entityId
        entityName
        entityState
        newValues
        oldValues
        userId
        userName
      }
    }
  }
`;

export const queryAuditRecordList = async (
    client: ApolloClient<NormalizedCacheObject>,
    filters?: GetAuditRecordsInput
): Promise<PagingResultModelOfAuditRecordModel | undefined> => {
    const { after, limit, entityName, entityState, order, dateFrom, dateTo } = filters ?? {};
    const { data, errors } = await client.query({
        variables: {
            input: {
                after,
                limit,
                entityName: entityName?.trim(),
                entityState: entityState,
                dateFrom,
                dateTo,
                order
            }
        },
        query: QUERY_AUDIT_RECORD_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            console.error(error);
        });
        throw new Error('An error has occurred during the query.');
    }

    return data?.auditRecords as PagingResultModelOfAuditRecordModel;
}
